/* @flow */
import * as React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Button from 'components/Button';
import Columns2 from 'components/Columns2';
import Container from 'components/Container';
import Heading from 'components/Heading';
import Image from 'components/Image';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';

type Props = {
  pickSyncMethod: string => void,
};

class AdminSisSyncPicker extends React.Component<Props> {
  renderOption(name: string, description: string, syncMethod: string, image: string) {
    return (
      <Text align="center" element="section">
        <Container flush size="small">
          <Row>
            <Image src={image} />
          </Row>
          <Heading level="3">{name}</Heading>
          <Row>
            <Text size="medium" color="thunder">
              {description}
            </Text>
          </Row>
          <Button level="secondary" onClick={() => this.props.pickSyncMethod(syncMethod)}>
            {name}
          </Button>
        </Container>
      </Text>
    );
  }

  renderFaqItem(question: string, answer: string) {
    return (
      <Row>
        <Row size="xsmall">
          <Text weight="semibold" size="medium" align="left">
            {question}
          </Text>
        </Row>
        <Text size="medium" align="left">
          {answer}
        </Text>
      </Row>
    );
  }

  render() {
    return (
      <div className="AdminSisSyncPicker">
        <Row size="xlarge">
          <Heading align="center" level="2">
            Synchronize Remind with your SIS
          </Heading>
          <Text align="center" size="medium">
            Remind will automatically create accounts and classes for your schools
          </Text>
        </Row>
        <Row size="xlarge">
          <Columns2>
            {this.renderOption(
              'Sync directly with Remind',
              'Automatically upload data through SFTP sync according to the Remind or OneRoster CSV format.',
              'SFTP',
              require('assets/images/admin/AdminSisSyncPicker/remind.svg')
            )}
            {this.renderOption(
              'Sync through Clever',
              'If you already use Clever for your district or school, add the Remind app to sync information from your SIS.',
              'Clever',
              require('assets/images/admin/AdminSisSyncPicker/clever.svg')
            )}
          </Columns2>
        </Row>
        <Box color="polar-bear">
          <BoxBody size="small">
            <Row>
              <Heading align="left" level="3">
                Frequently Asked Questions
              </Heading>
            </Row>
            <Columns2>
              <div>
                {this.renderFaqItem(
                  'Can I set up schools at different times?',
                  'Yes. With either Direct or Clever sync methods, you can set up sync for different schools at any time.'
                )}
                {this.renderFaqItem(
                  'Can I mix rostering methods across schools?',
                  'You may sync your entire district through one method at this time.'
                )}
              </div>
              <div>
                {this.renderFaqItem(
                  'Can I change my syncing method later?',
                  'We don’t support changing syncing methods at this time.'
                )}
              </div>
            </Columns2>
          </BoxBody>
          <BoxFooter size="small">
            <Link href={LinkConstants.ROSTERING_GUIDE} weight="semibold">
              Go to Help Center
            </Link>
          </BoxFooter>
        </Box>
      </div>
    );
  }
}

export default AdminSisSyncPicker;
